// Recovery helpers for Turbopack/webpack chunk load failures (stale or
// unreachable /_next/static assets). The Turbopack runtime memoizes the
// rejected promise, so re-importing never refetches — a full page reload
// is the only way to recover.

const RELOAD_GUARD_KEY = "rii.chunk-reload-at";
const RELOAD_GUARD_WINDOW_MS = 60_000;

const CHUNK_ERROR_PATTERNS = [
  /Failed to load chunk/i, // Turbopack runtime
  /Loading chunk [\w-]+ failed/i, // webpack fallback
  /Loading CSS chunk/i,
];

export function isChunkLoadError(value: unknown): boolean {
  if (!value) return false;
  const err = value as { name?: string; message?: string };
  if (err.name === "ChunkLoadError") return true;
  const message = typeof value === "string" ? value : err.message;
  return typeof message === "string" && CHUNK_ERROR_PATTERNS.some((p) => p.test(message));
}

/** True if a guarded reload was initiated. At most one reload per 60s per tab. */
export function attemptChunkReload(): boolean {
  if (typeof window === "undefined") return false;
  let last = 0;
  try {
    last = Number(window.sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;
  } catch {
    return false; // storage blocked: an auto-reload loop would be unguardable
  }
  if (Date.now() - last < RELOAD_GUARD_WINDOW_MS) return false;
  try {
    window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
